import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function ServiceAreasPage() {
  const primaryAreas = [
    { name: 'Allentown, PA', description: 'Full service coverage throughout Allentown and surrounding neighborhoods' },
    { name: 'Bethlehem, PA', description: 'Serving all of Bethlehem including downtown and residential areas' },
    { name: 'Easton, PA', description: 'Complete coverage of Easton and nearby communities' }
  ];

  const additionalAreas = [
    'Nazareth, PA',
    'Forks Township, PA',
    'Wind Gap, PA',
    'Pen Argyl, PA',
    'Bangor, PA',
    'Bath, PA',
    'Whitehall, PA',
    'Northampton, PA',
    'Hellertown, PA',
    'Tatamy, PA',
    'Phillipsburg, NJ',
    'Palmer Township, PA',
    'Wilson Borough, PA',
    'Bethlehem Township, PA'
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <section className="py-24 bg-gradient-to-br from-red-600 to-orange-500">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl sm:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
              Service Areas in the Lehigh Valley
            </h1>
            <p className="text-xl text-white/95 max-w-3xl mx-auto">
              Proudly serving Allentown, Bethlehem, Easton, and surrounding Pennsylvania and New Jersey communities with premier event entertainment rentals.
            </p>
          </div>
        </section>

        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Sora, sans-serif' }}>
                Primary Service Areas
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                We provide full-service event entertainment rentals throughout the Lehigh Valley region.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-24">
              {primaryAreas.map((area, index) => (
                <div 
                  key={index}
                  className="bg-gradient-to-br from-red-50 to-orange-50 p-8 rounded-2xl border border-red-100 hover:shadow-xl transition-all"
                >
                  <div className="w-16 h-16 flex items-center justify-center bg-red-600 rounded-2xl mb-6">
                    <i className="ri-map-pin-fill text-3xl text-white"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">{area.name}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{area.description}</p>
                </div>
              ))}
            </div>

            <div className="mb-24">
              <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center" style={{ fontFamily: 'Sora, sans-serif' }}>
                Additional Service Areas
              </h2>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {additionalAreas.map((area, index) => (
                  <div 
                    key={index}
                    className="bg-gradient-to-br from-gray-50 to-white p-4 rounded-xl border border-gray-200 hover:border-red-300 hover:shadow-lg transition-all"
                  >
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-red-100 rounded-lg flex-shrink-0">
                        <i className="ri-map-pin-line text-xl text-red-600"></i>
                      </div>
                      <p className="text-sm font-semibold text-gray-900">{area}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-12 mb-16">
              <div className="max-w-3xl mx-auto text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-red-600 rounded-2xl mx-auto mb-6">
                  <i className="ri-question-line text-4xl text-white"></i>
                </div>
                <h3 className="text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Sora, sans-serif' }}>
                  Don't See Your Area Listed?
                </h3>
                <p className="text-lg text-gray-600 mb-8">
                  We may still be able to serve you! Contact us to discuss your event location and we'll do our best to accommodate your needs. We regularly travel to surrounding areas for special events.
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                  <Link 
                    to="/contact" 
                    className="bg-red-600 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-red-700 transition-colors whitespace-nowrap w-full sm:w-auto"
                  >
                    Contact Us
                  </Link>
                  <a 
                    href="tel:6102532835" 
                    className="bg-gray-900 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-gray-800 transition-colors whitespace-nowrap w-full sm:w-auto"
                  >
                    <i className="ri-phone-fill mr-2"></i>
                    (610) 253-2835
                  </a>
                </div>
              </div>
            </div>

            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3024.8!2d-75.2207!3d40.6884!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDQxJzE4LjIiTiA3NcKwMTMnMTQuNSJX!5e0!3m2!1sen!2sus!4v1234567890"
                width="100%"
                height="500"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Fun Affairs Service Area Map"
              ></iframe>
            </div>
          </div>
        </section>

        <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Sora, sans-serif' }}>
                Why Choose a Local Company?
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white p-8 rounded-2xl shadow-lg">
                <div className="w-14 h-14 flex items-center justify-center bg-red-100 rounded-xl mb-6">
                  <i className="ri-time-fill text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Fast Response Times</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Being local means we can respond quickly to your needs, offer same-day service when available, and handle last-minute changes efficiently.
                </p>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg">
                <div className="w-14 h-14 flex items-center justify-center bg-red-100 rounded-xl mb-6">
                  <i className="ri-map-2-fill text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Local Knowledge</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  We know the Lehigh Valley area inside and out, including venue requirements, parking situations, and local regulations.
                </p>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg">
                <div className="w-14 h-14 flex items-center justify-center bg-red-100 rounded-xl mb-6">
                  <i className="ri-heart-fill text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Community Connection</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  As your neighbors, we're invested in our community's success and take pride in making local events special.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}